import {MessageCodes} from "../MessageCodes";
import ResultTable from "../../Table/ResultTable";
import ResultText from "../ResultText";
import CheckCSName from "../../CheckCSName";
import EmptyLine from "../../EmptyLine";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import OutputError from "../OutputError";
const RenderDescription = ({text, row, settings, globalVariables}) => {
    const getCsName = (row) => {
        if(row.highlight) {
            return (
                <div style={{color: 'red'}}>
                    {row.cross_section}
                </div>
            )
        }

        return row.cross_section
    }

    switch (row.error_id) {
        case MessageCodes.Internal.TXS01.error_id: {
            return (
                <>
                    <ResultText>
                        The distance between cross sections (channel downstream reach length) is more than {settings?.thresholds?.max_dsrl || '{max_dsrl}'} ft at the following {row?.data?.length} cross sections.
                        The highlighted cross sections satisfy all the following conditions for the 100yr (1%) profile. This may indicate the need for additional cross sections downstream of the highlighted cross sections. <EmptyLine />
                        {'\t'}1.	The energy loss is greater than 1 ft between the highlighted and next DS cross section. <EmptyLine height={1} />
                        {'\t'}2.	The conveyance ratio (highlighted divided by next DS cross section conveyance) is less than 0.7 or greater than 1.3. <EmptyLine height={1} />
                        {'\t'}3.	The velocity head of highlighted cross section compared to next DS cross section has changed by more than 0.5 ft.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', minWidth: 125}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right'}}>Distance (ft)</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                (row.data || [{}]).map(r => {
                                    return (
                                        <ResultRow>
                                            <ResultBodyCell style={{textAlign: 'left'}}><CheckCSName csName={getCsName(r)} csNameVal={r.cross_section} /></ResultBodyCell>
                                            <ResultBodyCell style={{textAlign: 'right'}}>{r.dsrl || '{dsrl}'}</ResultBodyCell>
                                        </ResultRow>
                                    )
                                })
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.XS02.error_id: {
            const profiles = Array.from(new Set(row.data.map(x => x.profile)))
            return profiles.map(p => {
                const cs_list = row.data.filter(x => x.profile === p)
                if(cs_list.length === 0) {
                    return ''
                }

                return (
                    <>
                        <ResultText>
                            For the {p} profile; the energy loss is greater than {settings?.thresholds?.head_loss || '{headloss}'} ft between the current and previous cross section at the following {cs_list?.length} cross sections. This may indicate the need for additional cross sections upstream.
                        </ResultText>
                        <ResultText><CheckCSName csNameList={cs_list?.map(x => x.cross_section)} /></ResultText>
                        <EmptyLine />
                    </>
                )
            })
        }
        case MessageCodes.Internal.XS03.error_id: {
            const profiles = Array.from(new Set(row.data.map(x => x.profile)))
            return profiles.map(p => {
                const cs_list = row.data.filter(x => x.profile === p)
                if(cs_list.length === 0) {
                    return ''
                }

                return (
                    <>
                        <ResultText>
                            For the {p} profile; the conveyance ratio (upstream conveyance divided by downstream conveyance) is less than {1-(settings?.thresholds?.conv_ratio || 0.3)} or greater than {1+(settings?.thresholds?.conv_ratio || 0.3)} at the following {cs_list?.length} cross sections. This may indicate the need for additional cross sections upstream.
                        </ResultText>
                        <ResultText><CheckCSName csNameList={cs_list?.map(x => x.cross_section)} /></ResultText>
                        <EmptyLine />
                    </>
                )
            })
        }
        case MessageCodes.Internal.XS04.error_id: {
            const profiles = Array.from(new Set(row.data.map(x => x.profile)))
            return profiles.map(p => {
                const cs_list = row.data.filter(x => x.profile === p)
                if(cs_list.length === 0) {
                    return ''
                }

                return (
                    <>
                        <ResultText>
                            For the {p} profile; the velocity head has changed by more than {1-(settings?.thresholds?.velocity_head || 0.5)} ft at the following {cs_list?.length} cross sections. This may indicate the need for additional cross sections upstream.
                        </ResultText>
                        <ResultText><CheckCSName csNameList={cs_list?.map(x => x.cross_section)} /></ResultText>
                        <EmptyLine />
                    </>
                )
            })
        }
        case MessageCodes.Internal.B26_NOOUT01.error_id: {
            return (
                <>
                    <OutputError error={row}/>
                </>
            )
        }
        case MessageCodes.Internal.B26_NOOUT02.error_id: {
            return (
                <>
                    <OutputError error={row}/>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}

export const B26 = {
    RenderDescription,
}